import $ from 'wee-dom';
import $events from 'wee-events';
import { $isFunction } from 'core/types';

export default class Overlay {
    constructor(options = {}) {
        this.$el = $('.js-overlay');

        if (options.callback && $isFunction(options.callback)) {
            this.callback = options.callback;
        }

        $events.on(this.$el, 'click', (e) => {
            if (this.callback) {
                this.callback();
            }

            if (options.closeOnClick) {
                this.close();
            }
        });
    }

    open() {
        this.$el.show();
    }

    close() {
        this.$el.hide();
    }

    toggle() {
        this.$el.toggle();
    }
}
